module.exports = __webpack_public_path__ + "static/media/export-dieline.e241bbf8.png";